import { render, staticRenderFns } from "./Tab-Solve-Shipment.vue?vue&type=template&id=4fea39c7"
import script from "./Tab-Solve-Shipment.vue?vue&type=script&lang=js"
export * from "./Tab-Solve-Shipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports